import React from 'react'
import { reportErrorMessage } from 'utils/errorReporter'
import styles from '../styles'

const BuildFrontierZone = ({ frontierZoneData }) => {
  const classes = styles()

  if (!frontierZoneData) {
    const error = 'Ocorreu um erro ao tratar os dados de Zona de Fronteira'
    reportErrorMessage(error, 'FrontierZone', frontierZoneData)

    return (
      <div className={classes.errorCaptured}>
        <span>{error}</span>
      </div>
    )
  }

  return (
    <div className={classes.expansibleContent}>
      <span>
        {frontierZoneData.consists ? 'Reside em zona de fronteira.' : 'Não reside em zona de fronteira.'}
      </span>
    </div>
  )
}

export default BuildFrontierZone
